//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {DateBox} from '@/components';

export default {
  name: "room-filter-condition",
  components: {DateBox},
  props: {
    currentScrollName: {
      type: String,
      default: 'booking',
    },
    durationData: {
      type: Object,
      default: {},
    },
    rooms: String | Number,
    person: String | Number,
  },

  data(){
    return {
      isShowCalendar: false,
    };
  },

  methods: {
    onScroll2Booking(itemType){
      this.$emit('on-head-nav', itemType)
    },

    onShowCalendar(){
      this.$emit('on-show-calendar');
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/RoomFilterCondition.vue